import {Column} from "../../common/Table/Interfaces";
import {FLEET_EXPENSES_TABLE_COLUMNS} from "../../../constants/translates";
import {
  FleetExpenseRowType,
  FleetExpensesModelAny,
  fleetExpensePaymentTypeMap,
} from "../../../models/FleetExpenses/FleetExpensesModel";
import React from "react";
import FleetExpenseActions from "./actions";

export const isFleetExpenseOfType = <Type extends FleetExpenseRowType>(entity: FleetExpensesModelAny, type: Type): entity is Extract<FleetExpensesModelAny, { type: Type }> => {
  return entity.type === type;
};

const COLUMNS = (): Column<FleetExpensesModelAny>[] => {
  return [
    {
      title: '#',
      dataIndex: '#',
      key: '#',
      sorter: false,
      isActive: true,
      order: 1,
      width: 35,
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.driver,
      dataIndex: 'driver',
      key: 'driver',
      sorter: false,
      isActive: true,
      order: 2,
      width: 140,
      render: (_, entity: FleetExpensesModelAny, __) => isFleetExpenseOfType(entity, 'driver') ? entity.driver.name : null,
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.card,
      dataIndex: 'card',
      key: 'card',
      sorter: false,
      isActive: true,
      order: 3,
      width: 140,
      render: (_, entity: FleetExpensesModelAny, __) => isFleetExpenseOfType(entity, 'driver')
        ? entity.card?.number ?? FLEET_EXPENSES_TABLE_COLUMNS.noCard
        : null,
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.tc,
      dataIndex: 'tc',
      key: 'tc',
      sorter: false,
      isActive: true,
      order: 4,
      width: 100,
      render: (_, entity: FleetExpensesModelAny, __) => isFleetExpenseOfType(entity, 'tc') ? entity.tc.tc_number : null,
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.spendingType,
      dataIndex: 'spending_type',
      key: 'spending_type',
      sorter: false,
      isActive: true,
      order: 5,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'spending-type') ? entity.spendingType.name : null
      ),
      width: 80
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.id,
      dataIndex: 'id',
      key: 'id',
      sorter: false,
      isActive: true,
      order: 6,
      width: 50,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'expense') ? entity.id : null
      ),
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.date,
      dataIndex: 'date',
      key: 'date',
      sorter: true,
      isActive: true,
      order: 7,
      width: 100,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'expense') ? entity.date : null
      ),
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.amount,
      dataIndex: 'amount',
      key: 'amount',
      sorter: true,
      isActive: true,
      order: 8,
      width: 80,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'expense') ? entity.amount : null
      ),
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.currency,
      dataIndex: 'currency',
      key: 'currency',
      sorter: false,
      isActive: true,
      order: 9,
      width: 50,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'expense') ? entity.currency : null
      ),
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.paymentType,
      dataIndex: 'payment_type',
      key: 'payment_type',
      sorter: false,
      isActive: true,
      order: 10,
      width: 80,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'expense') ? fleetExpensePaymentTypeMap.getLabel(entity.paymentType) : null
      ),
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.note,
      dataIndex: 'note',
      key: 'note',
      sorter: false,
      isActive: true,
      order: 11,
      width: 120,
      render: (_, entity: FleetExpensesModelAny, __) => (
        isFleetExpenseOfType(entity, 'expense') ? entity.note : null
      ),
    },
    {
      title: FLEET_EXPENSES_TABLE_COLUMNS.actions,
      dataIndex: 'actions',
      key: 'actions',
      sorter: false,
      order: 9999,
      width: 120,
      ellipsis: true,
      isActive: true,
      render: (_, entity: FleetExpensesModelAny, __) => {
        return <FleetExpenseActions entity={entity} />;
      }
    }
  ];
}

export default COLUMNS;